"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatterPercent = void 0;
const React = require("react");
const react_1 = require("react");
class NumberFormatterPercent extends react_1.Component {
    render() {
        const value = Number(this.props.value);
        let text = value.toFixed(2);
        // console.log("text", text);
        if (!value || value === null) {
            if (text === "NaN") {
                text = "";
            }
            else if (value === 0) {
                text = "0.00 %";
            }
            else {
                text = "----";
            }
        }
        else {
            if (value > 0) {
                text = `+${text} %`;
            }
            else {
                text = `0.00 %`;
            }
        }
        return React.createElement("span", null, text);
    }
}
exports.NumberFormatterPercent = NumberFormatterPercent;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/reporting/modules/reporting-list/components/report-container/claim-analytics/number-formatter-percent.tsx
// module id = 3561
// module chunks = 0